module.exports = __webpack_public_path__ + "img/duck-ripples.20568d895eb45ab36a2d54596af91a99.jpg";